export const dialogHistory = (state) => state.dialogHistory

export const getDialogState = (state) => (dialog) => state.dialog[dialog]

export const getDialogProperties = (state) => (dialog) => {
  return state.properties[dialog] || {}
}
